module.exports = __webpack_public_path__ + "drawdown.6b9b7818414699af4273079ee26cd8fc.png";